<template>
  <div style="width: 100vw; background: #f7f8fc">
    <img src="../../assets//yidong/15.png" alt="" style="width: 100%" />
    <div style="padding: 0 24px 100px">
      <div
        style="
          width: 100%;
          height: 88px;
          border-bottom: 1px solid #e1e4e9;
          display: flex;
        "
      >
        <div
          v-for="(item, i) in items"
          style="
            width: 33%;
            display: flex;
            flex-direction: column;
            align-items: center;
          "
        >
          <div
            style="
              margin: 24px 0 8px;
              height: 22px;
              line-height: 22px;
              color: #eb5b05;
              font-size: 16px;
              font-weight: bold;
            "
          >
            {{ item.age }}
          </div>
          <div
            style="
              color: #929292;
              height: 18px;
              font-size: 13px;
              line-height: 18px;
            "
          >
            {{ item.components }}
          </div>
        </div>
      </div>
      <div style="margin: 24px 0 16px">
        <div
          v-for="(item, i) in item1"
          :key="i"
          style="
            line-height: 27px;
            font-weight: 500;
            color: #000000;
            font-size: 12px;
          "
        >
          {{ item.age }}
        </div>
      </div>
      <div class="one_ddsss">
        <div class="one_ddsss2">
          <img src="../../assets//yidong//222.png" alt="" />
          <div>公众号</div>
        </div>
        <div class="one_ddsss2">
          <img src="../../assets/HelloWorld/guanwang_b.png" alt="" />
          <div>咨询客服</div>
        </div>
      </div>
      <div
        style="
          margin-top: 24px;
          font-size: 12px;
          line-height: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
        "
      >
        <div>Copyright ©2019—2023</div>
        <div>OCCloud Cloud All Rights Reserved.</div>
        <div>南京秀视信息技术有限公司</div>
        <div>版权所有 | 苏ICP备19033435号</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      items: [
        { age: '10+', components: '行业领域' },
        { age: '300+', components: '合作伙伴' },
        { age: '1000万+', components: '终端学员' },
      ],
      item1: [
        { age: '售前电话：' },
        { age: '投诉建议：ocloud@occloud.net' },
        { age: '上海公司：上海市静安区江场三路238号市北半岛国际中心' },
        { age: '南京公司：南京市建邺区奥体大街69号新城科技园' },
        { age: '北京公司：北京市朝阳区望京湖光中街一号鹏景阁大厦' },
      ],
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
  // 清空
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style lang="scss" scoped>
.one_ddsss {
  display: flex;
  padding: 0 0 24px;
  border-bottom: 1px solid #e1e4e9;
  // img{
  //     width: 66px;
  //     height: 66px;
  //     margin-right: 24px;
  // }
}
.one_ddsss2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 24px;

  img {
    width: 66px;
    height: 66px;
    margin-bottom: 8px;
  }
  div {
    height: 18px;
    line-height: 18px;
    font-size: 13px;
  }
}
</style>
